<template>
  <div class="message"
       :title="datetime"
       :class="{patient: fromPatient}">
    <p class="Paragraph1">{{ message.msg }}</p>
    <p class="Label1 gray-400">{{ formattedTime }}</p>
  </div>

</template>

<script>
  import {toPhilMoment} from '@/utils/dates';

  export default {
    name: "MessagePlainText",
    props: {
      message: {type: Object, required: true},
      fromPatient: {type: Boolean, required: true}
    },
    computed: {
      formattedTime() {
        return toPhilMoment(this.message.date).format('hh:mm a');
      },
      datetime() {
        return toPhilMoment(this.message.date).format('MMMM D, YYYY hh:mm a');
      },
    }
  }
</script>

<style lang="scss" scoped>
  .message {
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: radius(medium);
    padding: space(s) space(m);
    background-color: color(gray-50);

    .time {
      font-size: font(s);
    }
  }

  .patient {
    background-color: color(blue, brand);

    p {
      color: color(white, text) !important;
      word-break: break-word;
    }

    .time {
      text-align: right;
    }
  }
</style>